import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { HOME_OVERVIEW_FEED_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys/pageSegmentLoadKey.ts';

export const HOME_OVERVIEW_FEED_PAGE_SEGMENT: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: HOME_OVERVIEW_FEED_SEGMENT_KEY,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
});
